import UTIF from "utif";

/**
 * Decodes TIFF bytes into PNG data URLs (one per page) for display in `<img>`.
 */
export function decodeTiffBuffer(buffer: ArrayBuffer): string[] {
  const ifds = UTIF.decode(buffer);
  if (!ifds?.length) {
    throw new Error("Not a valid TIFF file.");
  }

  const out: string[] = [];
  for (let i = 0; i < ifds.length; i++) {
    const ifd = ifds[i];
    UTIF.decodeImage(buffer, ifd);
    const rgba = UTIF.toRGBA8(ifd);
    const w = ifd.width;
    const h = ifd.height;
    if (!w || !h || rgba.length < w * h * 4) {
      continue;
    }

    const canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext("2d");
    if (!ctx) {
      throw new Error("Could not get canvas context.");
    }

    const copy = new Uint8ClampedArray(rgba.length);
    copy.set(rgba);
    ctx.putImageData(new ImageData(copy, w, h), 0, 0);
    out.push(canvas.toDataURL("image/png"));
  }

  if (out.length === 0) {
    throw new Error(
      "Could not decode any TIFF page (unsupported compression or format).",
    );
  }

  return out;
}
